var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 0H2.66667C1.2 0 0.0133333 1.2 0.0133333 2.66667L0 21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V2.66667C24 1.2 22.8 0 21.3333 0ZM20 14.6667H14.6667V20H9.33333V14.6667H4V9.33333H9.33333V4H14.6667V9.33333H20V14.6667Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlue);
export default __webpack_public_path__ + "static/media/crossBlue.1eded86773944ce5b312ebc88173909d.svg";
export { ForwardRef as ReactComponent };